import { render, staticRenderFns } from "./AgentDetails.vue?vue&type=template&id=7b20b620&"
import script from "./AgentDetails.vue?vue&type=script&lang=ts&"
export * from "./AgentDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports